import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Header.css"; // Make sure to create and link the CSS file
import logo from "../images/logo12.webp";

const Header = () => {
  const [windowScroll, setWindowScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setWindowScroll(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleMenuToggle = () => {
    const menu = document.querySelector(".nav__menu");
    const closeBtn = document.querySelector("#close-menu-btn");
    const openBtn = document.querySelector("#open-menu-btn");
    menu.classList.toggle("active");
    closeBtn.style.display = menu.classList.contains("active")
      ? "block"
      : "none";
    openBtn.style.display = menu.classList.contains("active")
      ? "none"
      : "block";
  };

  const handleLinkClick = () => {
    const menu = document.querySelector(".nav__menu");
    const closeBtn = document.querySelector("#close-menu-btn");
    const openBtn = document.querySelector("#open-menu-btn");
    if (menu.classList.contains("active")) {
      menu.classList.remove("active");
      closeBtn.style.display = "none";
      openBtn.style.display = "block";
    }
  };

  return (
    <nav className={windowScroll ? "window-scroll" : ""}>
      <div className="container nav__container">
        <Link to="/">
          <img src={logo} alt="logo" className="logo" />
        </Link>
        <ul className="nav__menu">
          <li>
            <Link to="/" onClick={handleLinkClick}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/about" onClick={handleLinkClick}>
              About
            </Link>
          </li>
          <li>
            <Link to="/courses" onClick={handleLinkClick}>
              Courses
            </Link>
          </li>
          <li>
            <Link to="/services" onClick={handleLinkClick}>
              Services
            </Link>
          </li>
          <li>
            <Link to="/contact" onClick={handleLinkClick}>
              Contact
            </Link>
          </li>
        </ul>
        <button id="open-menu-btn" onClick={handleMenuToggle}>
          <i className="fas fa-bars"></i>
        </button>
        <button id="close-menu-btn" onClick={handleMenuToggle}>
          <i className="fas fa-times"></i>
        </button>
      </div>
    </nav>
  );
};

export default Header;
